import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Announcement } from "../../shared/models/announcement.model";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class AnnouncementService {
  private static readonly BASE_URL = `${environment.apiUrl}/announcements`;

  constructor(private http: HttpClient) {}

  /**
   * Create a new announcement (admin use only)
   */
  createAnnouncement(data: {
    title: string;
    content: string;
    title_hu?: string;
    content_hu?: string;
    is_global?: boolean;
  }): Observable<Announcement> {
    return this.http.post<Announcement>(AnnouncementService.BASE_URL, data);
  }


  /**
   * Get the latest pending announcement for the logged-in user
   */
  getPendingAnnouncement(): Observable<Announcement | null> {
    return this.http.get<Announcement | null>(`${AnnouncementService.BASE_URL}/pending`);
  }

  /**
   * Acknowledge an announcement (mark as seen by the user)
   */
  acknowledgeAnnouncement(announcement_id: number): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${AnnouncementService.BASE_URL}/acknowledge`,
      { announcement_id }
    );
  }

  /**
   * Admin: get all announcements
   */
  getAllAnnouncements(): Observable<Announcement[]> {
    return this.http.get<Announcement[]>(AnnouncementService.BASE_URL);
  }

  /**
   * Admin: delete an announcement
   */
  deleteAnnouncement(id: number): Observable<void> {
    return this.http.delete<void>(`${AnnouncementService.BASE_URL}/${id}`);
  }
}